(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6720],{

/***/ 67655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/schedule/event.m",
      function () {
        return __webpack_require__(41851);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _COMPONENTS_style_detailpackage_itinerarychorusM__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44915);
/* harmony import */ var _COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17550);
/* harmony import */ var _QUERIES_essential_agency_useAgencyInfo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2279);



/** component */ 

var ScheduleManagerComponent = function(param) {
    var query = param.query, eventDetail = param.eventDetail;
    var _agentCd = query.agentCd, agentCd = _agentCd === void 0 ? "" : _agentCd;
    var mgmDeptNm = eventDetail.mgmDeptNm, mgmUserTelNo = eventDetail.mgmUserTelNo, _mgmUserInfo = eventDetail.mgmUserInfo, mgmUserInfo = _mgmUserInfo === void 0 ? "N" : _mgmUserInfo, phoneDirect = eventDetail.phoneDirect, mgmUserEmail = eventDetail.mgmUserEmail, mgmUserNm = eventDetail.mgmUserNm;
    var agency = (0,_QUERIES_essential_agency_useAgencyInfo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(agentCd, {
        enabled: !!agentCd
    });
    var _body = agency.data.body, agenAddr = _body.agenAddr, agenFax = _body.agenFax, agenNm = _body.agenNm, agenTel = _body.agenTel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_itinerarychorusM__WEBPACK_IMPORTED_MODULE_1__/* .InfoList */ .Q4, {
        children: [
            !agentCd && mgmUserInfo === "Y" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "부서"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: mgmDeptNm
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "대표번호"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: phoneDirect
                            })
                        ]
                    })
                ]
            }),
            !agentCd && mgmUserInfo === "N" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "담당자"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: mgmUserNm
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "대표번호"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: mgmUserTelNo !== null && mgmUserTelNo !== void 0 ? mgmUserTelNo : phoneDirect
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "이메일"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: mgmUserEmail
                            })
                        ]
                    })
                ]
            }),
            agentCd && !agency.isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    agenNm && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "문의"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: agenNm
                            })
                        ]
                    }),
                    agenTel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "전화번호"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: agenTel
                            })
                        ]
                    }),
                    agenFax && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "FAX"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: agenFax
                            })
                        ]
                    }),
                    agenAddr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "주소"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: agenAddr
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ScheduleManager = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        logMsg: "ScheduleManager Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScheduleManagerComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScheduleManager);


/***/ }),

/***/ 44915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eq": function() { return /* binding */ Wrap; },
/* harmony export */   "I7": function() { return /* binding */ HeaderWrap; },
/* harmony export */   "Q4": function() { return /* binding */ InfoList; },
/* harmony export */   "hC": function() { return /* binding */ AccountNotice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _yb_styled_px2rem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53842);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding-bottom: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	display: flex;\n	height: 60px;\n	border-bottom: 1px solid var(--line-color);\n	justify-content: center;\n	align-items: center;\n\n	h3 {\n		font-size: 21px;\n		letter-spacing: -0.05em;\n		color: var(--emp-color);\n		overflow: hidden;\n		font-weight: bold;\n		text-overflow: ellipsis;\n		white-space: normal;\n		word-wrap: break-word;\n		word-break: break-all;\n		line-clamp: 1;\n	}\n\n	button {\n		position: absolute;\n		top: 50%;\n		right: 15px;\n		transform: translateY(-50%);\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 40px 15px 0;\n	line-height: 24px;\n	color: var(--default-color);\n	font-size: 13px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	padding: 30px 15px;\n	margin: 30px 15px 0;\n	border: 1px solid var(--line-color);\n	box-sizing: border-box;\n	gap: 5px;\n	flex-wrap: wrap;\n	flex-direction: column;\n\n	li {\n		position: relative;\n		display: flex;\n		padding-left: 12px;\n		line-height: 24px;\n\n		&:before {\n			position: absolute;\n			left: 0;\n			top: 10px;\n			width: 3px;\n			height: 3px;\n			border-radius: 50%;\n			background-color: var(--bl-color);\n			content: "";\n		}\n\n		> span {\n			margin-right: 18px;\n\n			&:last-child {\n				margin-right: 0;\n			}\n\n			&:first-child {\n				width: 60px;\n				color: var(--emp-color);\n				flex-shrink: 0;\n			}\n		}\n	}\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Wrap = _yb_styled_px2rem__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject());
var HeaderWrap = _yb_styled_px2rem__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject1());
var AccountNotice = _yb_styled_px2rem__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject2());
var InfoList = _yb_styled_px2rem__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul */ .ZP.ul(_templateObject3());



/***/ }),

/***/ 2279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useAgencyInfo";
/** ```
 * 대리점 정보 가져오기
 *   `/api/info/agency/${agentCd}`
 * parameter
 *  agentCd 대리점코드
 * ```*/ var getPath = function(agenCd) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/agency/").concat(agenCd);
};
/** ```
 * 대리점 정보 가져오기
 *   `/api/info/agency/${agentCd}`
 * parameter
 *  agentCd 대리점코드
 * ```*/ var useAgencyInfo = function(agentCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(agentCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(agentCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        placeholderData: {
            body: {
                agenNm: "",
                agenAddr: "",
                agenTel: "",
                agenFax: ""
            }
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useAgencyInfo);



/***/ }),

/***/ 95134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 공통 코드 조회
 *   `/esntl/common/code/${cmmnGrpCode}`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var key = "useCode";
var getPath = function(cmmnGrpCode) {
    if (!cmmnGrpCode) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/common/code/").concat(cmmnGrpCode);
};
/** ```
 * 공통 코드 조회
 *   `/esntl/common/code/${cmmnGrpCode}`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var usePortalCode = function(cmmnGrpCode, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(cmmnGrpCode)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(cmmnGrpCode)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (usePortalCode);



/***/ }),

/***/ 3889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var key = "useReview";
var getPath = function(goodsCd) {
    if (!goodsCd) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/product/").concat(goodsCd, "/review");
};
/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReview = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReview);



/***/ }),

/***/ 50297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useReviewAI";
/** ```
 * 리뷰 AI 조회
 *   `/portal/product/${goodsCd}/review/ai-info`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var getPath = function(goodsCd) {
    if (!goodsCd) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/product/").concat(goodsCd, "/review/ai-info");
};
/** ```
 * 리뷰 AI 조회
 *   `/portal/product/${goodsCd}/review/ai-info`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReviewAI = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewAI);



/***/ }),

/***/ 81258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oM": function() { return /* binding */ reviewLikeAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);



var key = "useReviewLike";
var getPath = function() {
    return "/bff/portal/reviewLike";
};
/** ```
 * 리뷰 좋아요 BFF
 *   `/bff/portal/reviewLike`
 * parameter
 *   `goodsCd` 상품코드
 *   `reviewId` 리뷰ID
 * ```*/ var reviewLikeAsync = function(params) {
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        url: getPath(),
        params: params
    });
};
/** ```
 * 리뷰 좋아요 BFF
 *   `/bff/portal/reviewLike`
 * parameter
 *   `goodsCd` 상품코드
 *   `reviewId` 리뷰ID
 * ```*/ var useReviewLike = function(params, options) {
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(),
                params: params
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useReviewLike)));



/***/ }),

/***/ 26163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87633);



var key = "useReviewLikeRecommender";
/** ```
 * 고객리뷰 추천 조회
 *   `/bff/portal/reviewLikeRecommender`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var getPath = function() {
    return "/bff/portal/reviewLikeRecommender";
};
/** ```
 * 고객리뷰 추천 조회
 *   `/bff/portal/reviewLikeRecommender`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReviewLikeRecommender = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(),
                params: {
                    goodsCd: goodsCd
                }
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewLikeRecommender);



/***/ }),

/***/ 37006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sW": function() { return /* binding */ reviewReportAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);



var key = "useReviewReport";
var getPath = function() {
    return "/bff/portal/reviewReport";
};
/** ```
 * 리뷰 신고하기 BFF
 *   `/bff/portal/reviewReport`
 * parameter
 *   `reportId` 리뷰ID
 *   `reportType` 신고하기 타입
 *   `reportCode` 신고하기 코드
 *   `reportContents` 신고하기 내용
 * ```*/ var reviewReportAsync = function(data) {
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        url: getPath(),
        method: "POST",
        data: data
    });
};
/** ```
 * 리뷰 신고하기 BFF
 *   `/bff/portal/reviewReport`
 * parameter
 *   `reportId` 리뷰ID
 *   `reportType` 신고하기 타입
 *   `reportCode` 신고하기 코드
 *   `reportContents` 신고하기 내용
 * ```*/ var useReviewReport = function(params, options) {
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(),
                method: "POST",
                params: params,
                data: params
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useReviewReport)));



/***/ }),

/***/ 56088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review/summary`
 * parameter
 *   `policyCodeIdHi` 공통코드 상위 ID
 * ```*/ var key = "useReviewSummary";
var getPath = function(goodsCd) {
    if (!goodsCd) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/product/").concat(goodsCd, "/review/summary");
};
/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review/summary`
 * parameter
 *   `policyCodeIdHi` 공통코드 상위 ID
 * ```*/ var useReviewSummary = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewSummary);



/***/ }),

/***/ 64380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 리뷰 사진 조회
 *   `/api/bff/vimeo/videos/${vimeoId}`
 * parameter
 *   `vimeoId
 * ```*/ var key = "useReviewSummary";
var getPath = function(vimeoId) {
    if (!vimeoId) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_SUPPORT_URL */ .Z.ENV_SUPPORT_URL, "/api/bff/vimeo/videos/").concat(vimeoId);
};
/** ```
 * 리뷰 사진 조회
 *   `/api/bff/vimeo/videos/${vimeoId}`
 * parameter
 *   `vimeoId
 * ```*/ var useReviewPictures = function(vimeoId, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(vimeoId)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(vimeoId)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: 1000 * 60 * 30,
        staleTime: 1000 * 60 * 30,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewPictures);



/***/ }),

/***/ 41851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _COMPONENTS_style_detailpackage_itinerarychorusM__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44915);
/* harmony import */ var _FRAMEWORK_ui_mobile_button_IconButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8956);
/* harmony import */ var _hooks_common_useOverlay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91864);
/* harmony import */ var _COMPONENTS_common_modal_share_Mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82864);
/* harmony import */ var _COMPONENTS_product_pages_detailPackage_mobile_detailHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23681);
/* harmony import */ var _COMPONENTS_product_pages_detailPackage_mobile_detailPrice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99939);
/* harmony import */ var _COMPONENTS_product_pages_detailPackage_mobile_detailSchedule__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9432);
/* harmony import */ var _COMPONENTS_product_pages_detailPackage_mobile_detailScheduleSummary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15981);
/* harmony import */ var _COMPONENTS_product_pages_schedule_mobile_ScheduleManager__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86155);






/** component */ 






var Page = function(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_hooks_common_useOverlay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), 1), open = ref[0];
    /** 대리점정보 로직 추가해야함.. */ var share = function() {
        open(function(overlay) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_modal_share_Mobile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, overlay), {
                baseUrl: "".concat(location.origin).concat(location.pathname),
                parameter: location.search
            }));
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_itinerarychorusM__WEBPACK_IMPORTED_MODULE_1__/* .Wrap */ .Eq, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_itinerarychorusM__WEBPACK_IMPORTED_MODULE_1__/* .HeaderWrap */ .I7, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: "여행 일정표"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_mobile_button_IconButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        type: "button",
                        icon: "share",
                        onClick: share,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "공유하기"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_pages_schedule_mobile_ScheduleManager__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_pages_detailPackage_mobile_detailHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props), {
                useScheduleView: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_pages_detailPackage_mobile_detailScheduleSummary__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_pages_detailPackage_mobile_detailPrice__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props), {
                usePointBtn: false
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_pages_detailPackage_mobile_detailSchedule__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props), {
                useScheduleView: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarychorusM__WEBPACK_IMPORTED_MODULE_1__/* .AccountNotice */ .hC, {
                children: "노랑풍선의 '예금주' 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여 당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선 고객센터로 문의하거나 신고하여 주시기 바랍니다."
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7700,2335,8866,1712,431,788,8235,6322,8484,9939,9774,2888,179], function() { return __webpack_exec__(67655); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);